import { render, staticRenderFns } from "./ApprRulePop.vue?vue&type=template&id=6d5a5eec&scoped=true"
import script from "./ApprRulePop.vue?vue&type=script&lang=js"
export * from "./ApprRulePop.vue?vue&type=script&lang=js"
import style0 from "./ApprRulePop.vue?vue&type=style&index=0&id=6d5a5eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a5eec",
  null
  
)

export default component.exports